import React, { useContext } from 'react';
import StatusIndicator from '../../components/StatusIndicator';
import { COMPLETED_STATUS, IN_PROGRESS_STATUS, WIN_THRESHOLD_INFO } from '../../utils/Constants';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';
import ResultTable from './ResultTable';
import { ABContext } from '../../contexts/ABContext';
import ABToast from './ABToast';
import { getDaysBetween } from '../../utils/ABHelper';

const ResultSection1 = () => {
    const abContext = useContext(ABContext);
    const { testData } = abContext;
    //const remainingDays = getDaysBetween(testData?.test_duration, testData?.analyzed_duration);
    //const dayText = remainingDays === 1 ? 'day' : 'days';


    return (
        <section>
            {
                (testData?.status === IN_PROGRESS_STATUS && testData?.notification)
                    ?
                    getDaysBetween(testData?.test_duration, testData?.analyzed_duration) <= 0
                        ?
                        <ABToast msg2={testData?.notification} />
                        : <ABToast msg2={testData?.notification} />
                    :
                    null
            }
            {
                (testData?.status === COMPLETED_STATUS && testData?.notification)
                    ?
                    <ABToast msg2={testData?.notification} />
                    :
                    null
            }

            <div className="tw-mt-6 tw-bg-white tw-rounded-md tw-border tw-border-[#dadbdd] tw-p-2">
                <div className='tw-flex tw-items-center tw-justify-between'>
                    <div className='tw-flex tw-items-center tw-gap-4'>
                        <label className='tw-text-sm tw-font-semibold tw-text-[#090A42]'>{testData?.applets[0]?.applet_name}</label>
                        {testData?.test_recommendation ? <StatusIndicator message={testData?.test_recommendation}  /> : null}
                    </div>
                    <div className='tw-flex tw-items-center tw-gap-1'>
                        <label className='tw-text-sm tw-text-[#6B778C] tw-font-semibold'>{'MLP'}:
                            <span className='tw-text-sm tw-font-semibold tw-text-[#091E42] tw-ms-1'>{`${testData?.win_threshold}% ${testData?.metric}`}</span>
                        </label>
                        <OverlayIcon message={WIN_THRESHOLD_INFO} />
                    </div>
                </div>
                <div className='tw-mt-4 tw-pb-4'>
                    <ResultTable />
                </div>
            </div>
        </section>
    );
}

export default ResultSection1;
